import React, { useEffect, useState } from "react";
import { Button, Typography, message } from "antd";
import {
  CheckCircleOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";
import { LoginFormLayout } from "../../layouts/LoginFormLayout/LoginFormLayout";
import { useParams } from "react-router-dom";
import { useUnsubscribeUserMutation } from "../../store/api/unsubscribe.api";

import classes from "./Unsubscribe.module.css";

const { Text } = Typography;

export function Unsubscribe() {
  const { token } = useParams();
  const [isUnsubscribed, setIsUnsubscribed] = useState(false);
  const [unsubscribeUser, { isLoading, error: apiError }] =
    useUnsubscribeUserMutation();

  const hasError = !token || apiError != null;

  useEffect(() => {
    if (!token) {
      message.error("Токен отсутствует");
    }
  }, [token]);

  async function handleUnsubscribe() {
    if (!token) return;

    try {
      await unsubscribeUser(token).unwrap();
      setIsUnsubscribed(true);
    } catch {
      message.error("Не удалось отписаться от рассылки");
    }
  }

  function renderContent() {
    if (hasError) {
      return (
        <>
          <Text className={classes.text}>
            Возникла ошибка, обратитесь в&nbsp;техподдержку{" "}
            <a href="mailto:support@tatbg.ru">support@tatbg.ru</a>
          </Text>
          <ExclamationCircleOutlined
            className={`${classes.icon} ${classes.iconError}`}
          />
        </>
      );
    }

    if (!isUnsubscribed) {
      return (
        <>
          <Text className={classes.text}>
            Вы уверены, что хотите отписаться?
          </Text>
          <div className={classes.buttons}>
            <Button
              onClick={handleUnsubscribe}
              loading={isLoading}
              type="primary"
              size="large"
            >
              Отписаться
            </Button>
            <Button size="large" href="https://tatbg.ru">
              Отмена
            </Button>
          </div>
        </>
      );
    }

    return (
      <>
        <Text className={classes.text}>
          Вы успешно отписались от&nbsp;рассылки
        </Text>
        <CheckCircleOutlined
          className={`${classes.icon} ${classes.iconSuccess}`}
        />
      </>
    );
  }

  return (
    <LoginFormLayout
      name="Управление подпиской"
      titleProps={{ level: 1, className: classes.title }}
      showSupportText={false}
      className={classes.wrapper}
      childrenContainerClassName={classes.container}
    >
      {renderContent()}
    </LoginFormLayout>
  );
}
